document.addEventListener('DOMContentLoaded',function(){document.querySelectorAll('[data-confirm-remove]').forEach(function(el){el.addEventListener('click',function(e){if(!confirm('Remove this item from your cart?'))e.preventDefault()})})});

document.addEventListener('click', function(event) {
  const thumbnail = event.target.closest('.product-thumb');
  if (!thumbnail) return;

  const gallery = thumbnail.closest('.product-gallery');
  if (!gallery) return;

  const mainImage = gallery.querySelector('.product-main-image');
  const thumbnailImage = thumbnail.querySelector('img');

  if (!mainImage || !thumbnailImage) return;

  mainImage.src = thumbnailImage.src;
  mainImage.srcset = '';

  gallery.querySelectorAll('.product-thumb').forEach(function(item) {
    item.classList.remove('active');
  });

  thumbnail.classList.add('active');
});
